import React from 'react';
import { Typography, Box } from '@mui/material';
import { CheckCircleOutline } from '@mui/icons-material';

function EHRComparison() {
  const coreFeatures = [
    'Client Management',
    'Clinical Records',
    'Scheduling',
    'Billing & Payments'
  ];

  const advantageFeatures = [
    'Agentic AI Automation',
    'Active Referral Network',
    'Professional Profiles',
    'Social & Community',
    'Provider Collaboration',
    'Care Team Coordination',
    'Organizations & Groups'
  ];

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-6xl mx-auto">
      {/* Core EHR Card */}
      <Box className="bg-gradient-to-br from-gray-50 to-white rounded-2xl shadow-lg border-2 border-gray-200 p-8 lg:p-10 flex flex-col items-center">
        <Typography variant="h3" className="text-2xl font-bold text-gray-900 mb-3 text-center">
          Complete EHR Foundation
        </Typography>
        <Typography variant="body2" className="text-gray-600 mb-4 text-center text-sm">
          Everything you expect from a modern EHR
        </Typography>
        <div className="w-full h-px bg-gray-300 mb-16"></div>
        <div className="space-y-4 inline-block">
          {coreFeatures.map((feature, index) => (
            <div key={index} className="flex items-center gap-3">
              <CheckCircleOutline className="text-gray-600 flex-shrink-0" sx={{ fontSize: 28 }} />
              <Typography variant="body1" className="text-gray-800 font-medium text-lg">
                {feature}
              </Typography>
            </div>
          ))}
        </div>
      </Box>

      {/* Halespring Advantage Card */}
      <Box className="bg-gradient-to-br from-blue-50 to-white rounded-2xl shadow-lg border-2 border-blue-200 p-8 lg:p-10 flex flex-col items-center">
        <Typography variant="h3" className="text-2xl font-bold text-blue-600 mb-3 text-center">
          + The Halespring Advantage
        </Typography>
        <Typography variant="body2" className="text-gray-600 mb-4 text-center text-sm">
          Unique features that transform your practice
        </Typography>
        <div className="w-full h-px bg-blue-300 mb-16"></div>
        <div className="grid grid-cols-2 gap-x-4 gap-y-4 inline-block">
          {advantageFeatures.map((feature, index) => (
            <div key={index} className="flex items-center gap-2">
              <CheckCircleOutline className="text-blue-600 flex-shrink-0" sx={{ fontSize: 24 }} />
              <Typography variant="body1" className="text-gray-800 font-medium text-base">
                {feature}
              </Typography>
            </div>
          ))}
        </div>
      </Box>
    </div>
  );
}

export default EHRComparison;
